// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__1-TAV","inputWrap":"CustomTip_inputWrap__2nSMq"};